'use strict';

/*global BasicProcess*/
/*global services*/
/*global blockElement*/
/*global unBlockElement*/
/*global app*/
/*global btLocation*/
/*global btArticle*/
/*global resSuccess*/

function TransferNoteNew(containerId, settings) {
  BasicProcess.call(this, containerId, settings);

  this.init();
}

TransferNoteNew.prototype = $.extend({}, BasicProcess.prototype, {
  constructor: 'TransferNoteNew',

  registerCallbacks: function registerCallbacks() {
    var _this = this;

    return _this;
  },

  //----------------------------------------------------------------------------

  onAfterSaveProcessItemResult: function onAfterSaveProcessItemResult($item, result) {
    var _this = this;

    if (_this.getFormBoolValue('IncludeAssigned')) {
      return _this;
    }

    _this.checkZeroStockLevel($item, result);

    return _this;
  },

  //----------------------------------------------------------------------------

  onChangeInputSearch: function onChangeInputSearch(/*input*/) {
    var _this = this;

    return _this;
  },

  //----------------------------------------------------------------------------

  processItemByArticleLocation: function processItemByArticleLocation(article, location) {
    var _this = this;

    _this.$searchInput.val('');

    var data = {
      ArticleAbbr: article.Abbr,
      ArticleAbbr2: article.Abbr2,
      ArticleDIN: article.DIN,
      ArticleISO: article.ISO,
      ArticleId: article.Id,
      ArticleName: article.Name,
      AmountRatio: article.AmountRatio,
      LocationAbbr: location ? location.Abbr : '',
      LocationId: location ? location.Id : 0,
      Unit: article.Unit,
      AreaId: article.AreaId,
      ExistsReservation: false,
    };

    _this.processNewItem(data, true, true);

    return _this;
  },

  processItemByArticle: function processItemByArticle(data) {
    var _this = this;

    if (services.get('warehouse-service').isLocationRecord(_this.getWarehouseId())) {
      //mame zbozi, musi jeste nacist umisteni
      services.get('barcode-service').scanAndFindBarcode(btLocation, '', _this.getWarehouseId(), function (res, resData) {
        if (res !== resSuccess) {
          return _this.showMessageHtmlAndFocusFilterInput(app.t('barcode.unknown'));
        }

        _this.processItemByArticleLocation(data, resData);
      });
    } else {
      _this.processItemByArticleLocation(data, {});
    }

    return _this;
  },

  processItemByLocation: function processItemByLocation(data) {
    var _this = this;

    if (data.IsOneArticle) {
      //jednodruhove umisteni - tam je to v pohode - nacteme po staru umisteni o umisteni
      blockElement(_this.$container);
      services.get('location-service').getLocationInfo({ stockId: _this.getWarehouseId(), location: data.Abbr }, function (res, data) {
        unBlockElement(_this.$container);

        _this.$searchInput.val('');

        if (res !== resSuccess) {
          return;
        }

        _this.processNewItem(data, true, false);
      });
    } else {
      //vicedruhove umisteni, musi jeste nacist zbozi

      services.get('barcode-service').scanAndFindBarcode(btArticle, '', _this.getWarehouseId(), function (res, resData) {
        if (res !== resSuccess) {
          return _this.showMessageHtmlAndFocusFilterInput(app.t('barcode.unknown'));
        }

        _this.processItemByArticleLocation(resData, data);
      });
    }

    return _this;
  },

  //----------------------------------------------------------------------------

  init: function init() {
    var _this = this;

    _this.registerCallbacks();

    return _this;
  }
});
